module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/lecce.1d3c89ed0b716c5820628e4707c9821a.jpg";